export default __webpack_public_path__ + "static/store-galaxy.ko-5f40bb04388bf3065d44ebecdd127d4a.png";